export default {
  root: {}
};
